export default {
  root: {}
};
